<div class="radio" id="radio" *transloco="let t">
  <mat-radio-group
    aria-labelledby="radio-group-label"
    class="radio-group"
    [(ngModel)]="selectedOption"
    (ngModelChange)="onSelectionChange($event)"
    [ngClass]="{'vertical': isVertical}"
    [disabled]="disabled">
    <mat-radio-button
      [color]="'primary'"
      class="radio-button"
      [value]="option.value"
      *ngFor="let option of options"
    >
      {{ option.label }}
    </mat-radio-button>
  </mat-radio-group>
</div>
